<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Code"
                    :value="form.code"
                    outlined
                    dense
                    disabled
                    hide-details="auto"
                    background-color="disabled"
                >
                </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field 
                    label="PO Code"
                    :value="form.purchase_order_code"
                    outlined
                    dense
                    hide-details="auto"
                    disabled
                    background-color="disabled"
                >
                </v-text-field >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <PDatePicker
                    label="Date"
                    v-model="form.date"
                    :rules="[isRequired]"
                    outlined
                    hide
                    dense
                />
            </v-col>
             <v-col cols="12" md="3">
                <v-autocomplete 
                    label="Warehouse"
                    v-model="form.warehouse_id"
                    :items="warehouses"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    :search-input="warehouseQuery"
                    @update:search-input="searchWarehouses"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <GoodReceiptFormLine
                    v-for="(line, index) in form.lines"
                    :key="line.key"
                    class="mb-2"
                    @deleteLine="handleDeleteLine(index)"
                    v-model="form.lines[index]"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn block depressed small @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    add line
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../utils/validations"
import { mapActions, mapGetters } from 'vuex';
import { randomSix } from '../../utils/toolkit';
import GoodReceiptFormLine from './GoodReceiptFormLine.vue'
import PDatePicker from './../common/PDatePicker.vue'
export default {
    name: "GoodReceiptForm",
    components: {
        PDatePicker,
        GoodReceiptFormLine,
    },
    props: {
        value: {
            type: Object,
        }
    },
    data() {
        return {
            form: {
                code: null,
                date: null,
                warehouse_id: null,
                purchase_order_code: null,
                purchase_order_id: null,
                lines: [],
                notes: ''
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null
            },
            warehouseQuery: ""
        }
    },
    watch: {
        form: {
            handler(form) {
                this.$emit("input", {...form, lines: [...form.lines]});
            },
            deep: true
        }
    },
    methods: {
        isRequired,
        ...mapActions({
            searchWarehouses: "purchase/warehouse/search"
        }),
        addLine() {
            this.form.lines.push({...this.line, key: randomSix()})
        },
        handleDeleteLine(index){
            this.form.lines.splice(index, 1)
        },
        validate() {
            return this.$refs.form.validate();
        }
    },
    computed: {
        ...mapGetters({
            warehouses: "purchase/warehouse/list"
        }),
    },
    mounted() {
        if(this.value) {
            this.form = {...this.value, lines: [...this.value.lines] };
        }
    }
}
</script>

<style>

</style>